export enum CalendarView {
  DayView = 'timeGridDay',
  WeekView = 'timeGridWeek',
  MonthView = 'dayGridMonth',
}
